<div class="custom-rate-popup">
    <form [formGroup]="specialRateForm">
        <div class="top-outer">
            <div class="popup-heading">
                <h4>Special Rate for Half Length </h4>
                <p>Public Rate Comparison - (Daily - ${{dailyRate}}) & (Monthly - ${{monthlyRate}})</p>
            </div>
            <div class="close-outer">
                <img (click)="close()" src="../../../../../assets/images/close-icon-model.svg" alt="Close" />
            </div>
        </div>
        <div class="offer-summary-outer">
            <div class="grid">
                <div class="col">
                    <div class="group-outer">
                        <label for="code">Code <span class="custom-star"> *</span></label>
                        <input type="text" formControlName="code" (keydown)="preventFirstSpace($event)" pInputText placeholder="Enter Code" maxlength="15" />

<div *ngIf="specialRateForm.get('code')?.hasError('required')  && (specialRateForm.get('code')?.dirty || specialRateForm.get('code')?.touched)"
                            class="validation-error"> This field is required*</div>
                        <div
                            *ngIf="specialRateForm.get('code')?.hasError('minlength')  && (specialRateForm.get('code')?.dirty || specialRateForm.get('code')?.touched)">
                            <div class="validation-error">Minimum 3 characters are required*</div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="group-outer">
                        <label for="dailyRate">Daily Rate <span class="custom-star"> *</span></label>
                        <input type="text" formControlName="dailyRate" pInputText
                            (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" placeholder="Enter daily rate"
                            maxlength="8" />

<div class="validation-error"
                            *ngIf="specialRateForm.get('dailyRate')?.hasError('required') && (specialRateForm.get('dailyRate')?.dirty || specialRateForm.get('dailyRate')?.touched)">
                            This field is required*
                        </div>
                        <div class="validation-error"
                            *ngIf="specialRateForm.get('dailyRate')?.hasError('lessThanZero') && !specialRateForm.get('dailyRate')?.hasError('required') && (specialRateForm.get('dailyRate')?.dirty || specialRateForm.get('dailyRate')?.touched)">
                            Charge must be greater than 0*
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="group-outer">
                        <label for="monthlyRate">Monthly Rate <span class="custom-star"> *</span></label>
                        <input type="text" formControlName="monthlyRate" pInputText
                            (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" placeholder="Enter monthly rate"
                            maxlength="8" />

<div class="validation-error"
                            *ngIf="specialRateForm.get('monthlyRate')?.hasError('required') && (specialRateForm.get('monthlyRate')?.dirty || specialRateForm.get('monthlyRate')?.touched)">
                            This field is required*
                        </div>
                        <div class="validation-error"
                            *ngIf="specialRateForm.get('monthlyRate')?.hasError('lessThanZero') && !specialRateForm.get('monthlyRate')?.hasError('required') && (specialRateForm.get('monthlyRate')?.dirty || specialRateForm.get('monthlyRate')?.touched)">
                            Charge must be greater than 0*
                        </div>
                    </div>
                </div>
            </div>
            <div class="group-outer">
                <label for="description">Description <span class="custom-star"> *</span></label>
                <textarea pInputTextarea cols="30" placeholder="Type here:" formControlName="description"
                    maxlength="512"></textarea>

                <div class="validation-error"
                    *ngIf="specialRateForm.get('description')?.hasError('required')  && (specialRateForm.get('description')?.dirty || specialRateForm.get('description')?.touched)">
                    This field is required*
                </div>
                <div class="validation-error"
                    *ngIf="specialRateForm.get('description')?.hasError('minlength')  && (specialRateForm.get('description')?.dirty || specialRateForm.get('description')?.touched)">
                    Minimum 3 characters are required*
                </div>
                <div  class="validation-error" *ngIf="specialRateForm.get('description')?.invalid && (specialRateForm.get('description')?.dirty || specialRateForm.get('description')?.touched)">
                    <div *ngIf="specialRateForm.get('description')?.errors?.['containsHtml']">HTML tags are not allowed.</div>
                  </div>
            </div>
        </div>
        <div class="next-btn">
            <div class="field">
                <p-button [label]="isEditMode ? 'Update' : 'Save'" class="ml-auto" (onClick)="save()"></p-button>
            </div>
        </div>
    </form>
</div>